var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("กำลังนำท่านสู่หน้าล็อคอิน...")])
}
var staticRenderFns = []

export { render, staticRenderFns }